import axios from 'axios'
import dayjs from 'dayjs'

/**
 * Before any API call, retrieve the clientID from the evnironmet to set the required X-IBM-Client-Id value
 **/
async function checkCredential(config) {
  if (!config.url.includes('apimanagerconsumercredentials')) {
    if (!window.api_credentials && !window.api_credentials_request) {
      window.api_credentials_request = axios
        .get('/portal/config/apimanagerconsumercredentials.json')
        .then(resp => (window.api_credentials = resp.data))
        .catch(err => console.log('Error fetching credentials ' + err))
    }
    await window.api_credentials_request
    config.headers.common['X-IBM-Client-Id'] = window.api_credentials?.clientId
  }

  return config
}

axios.interceptors.request.use(checkCredential)

//default start 0 i rows 10 amb max 50
export async function querySearch(
  start,
  rows,
  lang,
  search,
  theme,
  subtheme,
  detail,
  territories,
  source,
  sortByFilter,
  range,
  territory,
  dimensions
) {
  console.log(
    start,
    rows,
    lang,
    search,
    theme,
    subtheme,
    detail,
    territories,
    source,
    sortByFilter,
    range
  )
  let thesaurus = '*'
  let thesaurusIds = null
  let thesaurusRouteValues = []
  if (theme) thesaurusRouteValues.push(theme)
  if (subtheme) thesaurusRouteValues.push(subtheme)
  if (detail) thesaurusRouteValues.push(detail)
  if (thesaurusRouteValues.length !== 0) {
    let flattenedValues = thesaurusRouteValues
      .join(',')
      .split(',')
      .filter(Boolean)

    if (flattenedValues.every(value => /^\d+$/.test(value))) {
      thesaurusIds = flattenedValues.join(',')
    } else if (theme && subtheme && detail) thesaurus = theme + ',' + subtheme + ',' + detail
    else if (theme && subtheme) thesaurus = theme + ',' + subtheme
    else if (theme) thesaurus = theme
  }
  //WARREO PQ FUNCIONI
  if (search === undefined) search = ''
  let objectParams = {
    params: {
      query: search,
      start: start,
      rows: rows,
      language: lang,
      territories: territories,
      source: source,
      territory: territory,
      dimensions: dimensions,
      //thesaurus
      //sortByFilter
    },
  }
  if (thesaurusIds) {
    objectParams.params.thesaurusIds = thesaurusIds
  } else if (thesaurus !== '*') objectParams.params.thesaurus = thesaurus
  if (sortByFilter !== 'relevance') objectParams.params.sortByFilter = sortByFilter
  if (range) objectParams.params.publishDateRange = range
  const response = await axios
    .get(process.env.VUE_APP_API_URL + 'search', objectParams)
    .then(resp => {
      let dataSearch = resp.data
      return dataSearch
    })
    .catch(function (err) {
      if (err.response.status === 429 || err.response.httpCode === '429') {
        let currentLanguage = window.location.pathname
          .split('/')
          .find(el => el === 'ca' || el === 'es' || el === 'en')
        window.location.assign('/' + currentLanguage + '/page-429')
      } else {
        return {
          code: 500,
        }
      }
    })
  return response
}

export async function getItemById(hostId, lang, source, mustTrace) {
  let objectParams = {
    params: { id: hostId, language: lang },
  }
  if (mustTrace) {
    objectParams.params.mustTrace = mustTrace
  }
  const response = await axios
    .get(process.env.VUE_APP_API_URL + (source ? source : 'item'), objectParams)
    .then(resp => {
      return resp.data
    })
    .catch(function (err) {
      if (err.response.status === 429 || err.response.httpCode === '429') {
        let currentLanguage = window.location.pathname
          .split('/')
          .find(el => el === 'ca' || el === 'es' || el === 'en')
        window.location.assign('/' + currentLanguage + '/page-429')
      } else {
        return {
          code: 500,
        }
      }
    })
  return response
}

const THESAURUS_DICT = {
  population: ['Població', 'Población', 'Population'],
  economy: ['Economia i treball', 'Economía y trabajo', 'Economy and labour market'],
  environment: ['Medi urbà', 'Medio urbano', 'Urban environment'],
  transport: ['Transports i mobilitat', 'Transporte y mobilidad', 'Transport and mobility'],
  housing: ['Habitatge', 'Vivienda', 'Housing'],
  society: ['Societat', 'Sociedad', 'Society'],
  politics: ['Política', 'Política', 'Politics'],
  administration: [
    'Administració municipal',
    'Administración municipal',
    'Municipal administration',
  ],
  cartography: [
    'Codis~ classificacions i cartografia',
    'Códigos~ clasificaciones y cartografía',
    'Codes~ classification and cartography',
  ],
}
function fillIds(node) {
  if (node.id === undefined || node.id === null) {
    let id = Object.keys(THESAURUS_DICT).find(k => THESAURUS_DICT[k].indexOf(node.label) >= 0)
    if (id) node.id = id
  }
  if (node.theme) node.theme.forEach(child => fillIds(child))
  else if (node.subThemes) node.subThemes.forEach(child => fillIds(child))
}
export async function getThesaurus(lang) {
  const response = await axios
    .get(process.env.VUE_APP_API_URL + 'thesaurus', {
      params: { language: lang },
    })
    .then(resp => {
      fillIds(resp.data)
      return resp.data
    })
    .catch(function () {
      // if (err.response.status === 429 || err.response.httpCode === '429') {
      //   let currentLanguage = window.location.pathname
      //     .split('/')
      //     .find(el => el === 'ca' || el === 'es' || el === 'en')
      //   window.location.assign('/' + currentLanguage + '/page-429')
      // } else {
      return {
        code: 500,
      }
      // }
    })
  return response
}

export async function getTypesOfContent(lang) {
  const response = await axios
    .get(process.env.VUE_APP_API_URL + 'types', {
      params: { language: lang },
    })
    .then(resp => {
      return resp.data
    })
    .catch(function () {
      // if (err.response.status === 429 || err.response.httpCode === '429') {
      //   let currentLanguage = window.location.pathname
      //     .split('/')
      //     .find(el => el === 'ca' || el === 'es' || el === 'en')
      //   window.location.assign('/' + currentLanguage + '/page-429')
      // } else {
      return {
        code: 500,
      }
      // }
    })
  return response
}
export async function getMicrodataFileMetas(id) {
  console.log(id)
  const response = await axios
    //process.env.VUE_APP_API_URL + 'microdata/csv'
    //.get(process.env.BASE_URL + 'fake-microdata.json')
    .get(process.env.VUE_APP_API_URL + 'microdata/csv', {
      params: { id: id },
    })
    .then(resp => {
      // porque el "_id" no lleva el count incrustado
      let theIds = resp.data.data.find(d => d.label === '_id')
      if (theIds && !theIds.count) theIds.count = resp.data.count
      return resp.data
    })
    .catch(function () {
      // if (err.response.status === 429 || err.response.httpCode === '429') {
      //   let currentLanguage = window.location.pathname
      //     .split('/')
      //     .find(el => el === 'ca' || el === 'es' || el === 'en')
      //   window.location.assign('/' + currentLanguage + '/page-429')
      // } else {
      return {
        code: 500,
      }
      // }
    })
  return response
}

const geoCache = {}
export async function getGeojson(url) {
  const arrGeoDis = ['districte', 'distrito', 'district']
  const arrGeoBar = ['barri', 'barrio', 'neighborhood']
  const arrGeoAeb = ['àrea estadística bàsica', 'área estadística básica', 'basic statistical area']
  const arrGeoCen = ['secció censal', 'sección censal', 'census district']

  const geoOptions = arrGeoDis.concat(arrGeoBar, arrGeoAeb, arrGeoCen)
  if (geoOptions.indexOf(url.toLowerCase()) < 0) {
    return null
  } else {
    let config = {
      transformRequest: [
        (data, headers) => {
          delete headers.common['X-IBM-Client-Id']
          return data
        },
      ],
    }
    const geoDistrict =
      'districte.json?accept=contents&fmetoken=a65e5d4eed36e1dd00ee9c7fd5874285837aafdc'
    const geoBarri = 'barri.json?accept=contents&fmetoken=a65e5d4eed36e1dd00ee9c7fd5874285837aafdc'
    const geoAeb = 'aeb.json?accept=contents&fmetoken=a65e5d4eed36e1dd00ee9c7fd5874285837aafdc'
    const geoCens =
      'sec_cens.json?accept=contents&fmetoken=a65e5d4eed36e1dd00ee9c7fd5874285837aafdc'
    let geoPick
    if (arrGeoDis.indexOf(url.toLowerCase()) >= 0) geoPick = geoDistrict
    else if (arrGeoBar.indexOf(url.toLowerCase()) >= 0) geoPick = geoBarri
    else if (arrGeoAeb.indexOf(url.toLowerCase()) >= 0) geoPick = geoAeb
    else geoPick = geoCens

    let cachedUrl = process.env.VUE_APP_GEOJSON_URL + geoPick
    if (geoCache[cachedUrl]) return new Promise(res => res(geoCache[cachedUrl]))
    else {
      const response = await axios
        .get(cachedUrl, config)
        .then(resp => {
          geoCache[cachedUrl] = resp.data
          return resp.data
        })
        .catch(function () {
          // if (err.response.status === 429 || err.response.httpCode === '429') {
          //   let currentLanguage = window.location.pathname
          //     .split('/')
          //     .find(el => el === 'ca' || el === 'es' || el === 'en')
          //   window.location.assign('/' + currentLanguage + '/page-429')
          // } else {
          return {
            code: 500,
          }
          // }
        })
      return response
    }
  }
}

export async function getRelateds(id, lang) {
  const response = await axios
    .get(process.env.VUE_APP_API_URL + 'related', {
      params: { id: id, language: lang },
    })
    .then(resp => {
      return resp.data
    })
    .catch(function () {
      // if (err.response.status === 429 || err.response.httpCode === '429') {
      //   let currentLanguage = window.location.pathname
      //     .split('/')
      //     .find(el => el === 'ca' || el === 'es' || el === 'en')
      //   window.location.assign('/' + currentLanguage + '/page-429')
      // } else {
      return {
        code: 500,
      }
      // }
    })
  return response
}

//rows entre 1 - 100
export async function getMicrodataFileData(id, rows, offset, search, sort, filter) {
  // process.env.VUE_APP_API_URL + 'microdata/csvdata'
  // {params: { id: id, rows: rows, start: offset, search: search, sort: sort, filter: filter },}

  //search[columna]="whatever"
  //sort=nomColumna asc/desc

  // let parseSearch = ''
  // search.forEach(el => {
  //   if (parseSearch !== '') parseSearch += '&'
  //   parseSearch += 'search[' + el.column + ']:' + el.text
  // })
  let objectParams = new URLSearchParams()
  if (id) objectParams.append('id', id)
  if (rows) objectParams.append('rows', rows)
  if (offset) objectParams.append('start', offset)
  //if (parseSearch !== '') objectParams.search = parseSearch
  if (sort) objectParams.append('sort', sort)
  if (search.length !== 0) {
    search.forEach(el => {
      objectParams.append('search[' + el.column + ']', el.text)
    })
  }
  if (filter.length !== 0) {
    filter.forEach(el => {
      objectParams.append('search[' + el.column + ']', el.value)
    })
  }
  console.log(id, offset, rows, 'searchParams', sort, filter)
  const response = await axios
    //.get(process.env.BASE_URL + 'fake-microdata.json')
    .get(process.env.VUE_APP_API_URL + 'microdata/csvdata', {
      params: objectParams,
    })
    .then(resp => {
      return resp.data
    })
    .catch(function () {
      // if (err.response.status === 429 || err.response.httpCode === '429') {
      //   let currentLanguage = window.location.pathname
      //     .split('/')
      //     .find(el => el === 'ca' || el === 'es' || el === 'en')
      //   window.location.assign('/' + currentLanguage + '/page-429')
      // } else {
      return {
        code: 500,
      }
      // }
    })
  return response
}

export async function savedownload(language, indicatorId, fileNameDownload) {
  let now = new Date()
  const objectParams = new URLSearchParams()
  objectParams.append('dateData', dayjs(now).format('YYYY-MM-DDTHH:mm:ss[Z]'))
  objectParams.append('language', language)
  objectParams.append('indicatorId', indicatorId)
  objectParams.append('fileNameDownload', fileNameDownload)

  const response = await axios
    .post(process.env.VUE_APP_API_URL + 'api/stats/save/download', objectParams)
    .then(resp => {
      return resp.data
    })
    .catch(function () {
      // if (err.response.status === 429 || err.response.httpCode === '429') {
      //   let currentLanguage = window.location.pathname
      //     .split('/')
      //     .find(el => el === 'ca' || el === 'es' || el === 'en')
      //   window.location.assign('/' + currentLanguage + '/page-429')
      // } else {
      return {
        code: 500,
      }
      // }
    })
  return response
}
